import { render, staticRenderFns } from "./VCalendarLegend.vue?vue&type=template&id=e2aca7b4&"
import script from "./VCalendarLegend.vue?vue&type=script&lang=js&"
export * from "./VCalendarLegend.vue?vue&type=script&lang=js&"
import style0 from "./VCalendarLegend.vue?vue&type=style&index=0&id=e2aca7b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports